import { motion } from "framer-motion";

/* Lathe thread-cut divider — the cutting tool travels across and leaves a thread profile behind */
const EASE = [0.16, 1, 0.3, 1];
const REVEAL_VIEWPORT = { once: true, amount: 0.6 };
const REVEAL_TRANSITION = { duration: 1.6, ease: EASE };
const PATH_HIDDEN = { pathLength: 0 };
const PATH_SHOWN = { pathLength: 1 };
const TOOL_START = { left: "0%", opacity: 0 };
const TOOL_END = { left: "100%", opacity: [0, 1, 1, 0] };

export default function ThreadDivider({ label = "PRECISION THREADING", dark = false }) {
  const teeth = Array.from({ length: 34 });

  return (
    <div
      className={`relative overflow-hidden ${dark ? "bg-ink" : "bg-white"}`}
      data-testid="thread-divider"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-8 flex items-center gap-6">
        <span
          className={`hidden sm:block shrink-0 font-sans font-semibold text-[11px] tracking-[0.14em] ${
            dark ? "text-blue-300" : "text-steel"
          }`}
        >
          {label}
        </span>

        <div className="relative flex-1 h-8">
          <div
            className={`absolute left-0 right-0 top-1/2 h-px ${
              dark ? "bg-slate-700" : "bg-steel-light"
            }`}
          />
          <svg className="absolute inset-0 w-full h-full" preserveAspectRatio="none" viewBox="0 0 340 32">
            <motion.path
              d={teeth
                .map((_, i) => `${i === 0 ? "M" : "L"}${i * 10} 24 L${i * 10 + 5} 8`)
                .join(" ")}
              fill="none"
              stroke={dark ? "#7FB2DC" : "#1B5FAA"}
              strokeWidth="1.6"
              opacity="0.85"
              initial={PATH_HIDDEN}
              whileInView={PATH_SHOWN}
              viewport={REVEAL_VIEWPORT}
              transition={REVEAL_TRANSITION}
            />
          </svg>

          <motion.div
            initial={TOOL_START}
            whileInView={TOOL_END}
            viewport={REVEAL_VIEWPORT}
            transition={REVEAL_TRANSITION}
            className="absolute top-0"
          >
            <svg width="14" height="16" viewBox="0 0 14 16">
              <path d="M7 16 L0 0 L14 0 Z" fill={dark ? "#7FB2DC" : "#1B5FAA"} />
            </svg>
          </motion.div>
        </div>

        <span
          className={`shrink-0 font-sans font-semibold text-[11px] tracking-[0.14em] ${
            dark ? "text-blue-300" : "text-steel"
          }`}
        >
          REW
        </span>
      </div>
    </div>
  );
}
